module.exports = __webpack_public_path__ + "static/media/duckTrails.4df700df.jpg";